/* --------------------------------------------------------------------------
   kindooly.js

   Kleine Ergaenzungen, die das Theme nicht mitbringt. Bewusst kurz, ohne
   Abhaengigkeiten, und ohne in Shrines eigenes Verhalten einzugreifen.

   Eingebunden in layout/theme.liquid.
   -------------------------------------------------------------------------- */

(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     Escape schliesst die Warenkorbschublade

     Gefunden am 2026-08-27 im Browser: Die Schublade oeffnet sich, der Fokus
     springt korrekt hinein, aber Escape schliesst sie nicht. Wer mit der
     Tastatur navigiert, sitzt darin fest und muss sich zum Schliessen-Knopf
     durchtabben.

     03_Designsystem.md verlangt ausdruecklich "Warenkorbschublade mit
     Fokusfalle und Escape". Die Fokusfalle bringt Shrine mit, Escape nicht.

     Shrines main.js ist verschleiert und nicht pruefbar, deshalb wird hier
     nichts umgebaut, sondern nur ergaenzt: Bei Escape wird derselbe
     Schliessen-Knopf ausgeloest, den auch die Maus benutzt. Damit laeuft
     Shrines eigene Aufraeumlogik unveraendert mit, einschliesslich der
     Rueckgabe des Fokus.
     ------------------------------------------------------------------------ */

  var SCHUBLADEN = 'cart-drawer, .cart-drawer, #CartDrawer, .drawer[data-type="modal"]';

  function istSichtbar(el) {
    if (!el) return false;
    var s = window.getComputedStyle(el);
    return s.visibility !== 'hidden' && s.display !== 'none';
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.keyCode !== 27) return;

    var offene = Array.prototype.filter.call(
      document.querySelectorAll(SCHUBLADEN),
      istSichtbar
    );
    if (!offene.length) return;

    // Nur die oberste schliessen, nicht alle auf einmal
    var schublade = offene[offene.length - 1];
    var knopf = schublade.querySelector('.drawer__close, [aria-label="Schließen"], [aria-label="Close"]');
    if (!knopf) return;

    knopf.click();

    // Nicht auch noch andere Escape-Behandlung ausloesen, wenn wir schon
    // etwas geschlossen haben
    e.stopPropagation();
  });

})();

/* ---------------------------------------------------------------------------
   Rabattlasche, 2026-08-29

   Loest Shrines promo-popup ab. Der Unterschied ist nicht die Optik, sondern
   das Verhalten: Diese Karte legt sich nicht ueber die Seite und erzwingt
   keine Entscheidung. Wer sie wegklickt, behaelt einen schmalen Reiter am
   Rand und kann sie jederzeit wieder oeffnen.

   Der Zustand liegt in localStorage. Faellt der aus, etwa im privaten Fenster,
   erscheint die Karte wieder. Das ist der harmlose Fall und wird deshalb
   nicht abgefangen.
--------------------------------------------------------------------------- */
(function () {
  var wurzel = document.getElementById('KindoolyRabattlasche');
  if (!wurzel) return;

  var SCHLUESSEL = 'kindooly-rabattlasche-zu-bis';
  var karte = wurzel.querySelector('.kindooly-rl__karte');
  var reiter = wurzel.querySelector('.kindooly-rl__reiter');
  var zu = wurzel.querySelector('.kindooly-rl__zu');
  var verzoegerung = (parseInt(wurzel.dataset.verzoegerung, 10) || 20) * 1000;
  var tage = parseInt(wurzel.dataset.tage, 10) || 30;

  function lies() {
    try { return parseInt(localStorage.getItem(SCHLUESSEL), 10) || 0; } catch (e) { return 0; }
  }

  function merke() {
    try { localStorage.setItem(SCHLUESSEL, String(Date.now() + tage * 86400000)); } catch (e) { /* egal */ }
  }

  function oeffnen() {
    wurzel.classList.add('kindooly-rl--offen');
    reiter.setAttribute('aria-expanded', 'true');
  }

  function schliessen() {
    wurzel.classList.remove('kindooly-rl--offen');
    reiter.setAttribute('aria-expanded', 'false');
    merke();
  }

  // Nach erfolgreicher Anmeldung haengt Shopify ?form_type=customer an die
  // URL. Dann soll die Karte offen sein, damit der Dank auch gelesen wird.
  var geschafft = window.location.search.indexOf('customer_posted=true') > -1
    || wurzel.querySelector('.kindooly-rl__dank') !== null;

  wurzel.hidden = false;

  if (geschafft) {
    oeffnen();
  } else if (lies() < Date.now()) {
    window.setTimeout(oeffnen, verzoegerung);
  }

  reiter.addEventListener('click', function () {
    if (wurzel.classList.contains('kindooly-rl--offen')) { schliessen(); } else { oeffnen(); }
  });

  zu.addEventListener('click', schliessen);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && wurzel.classList.contains('kindooly-rl--offen')) schliessen();
  });
})();

/* ---------------------------------------------------------------------------
   Aufklappfelder als Akkordeon, 2026-08-29

   Das name-Attribut an <details> macht das eigentlich von selbst, es steht in
   kindooly-details.liquid und kindooly-faq.liquid. Es wirkt aber erst ab
   Chrome 120, Firefox 130 und Safari 17.2, und Anjas Browser am 2026-08-29
   gehoerte nicht dazu: Es blieben mehrere Felder offen.

   Dieses Skript macht dasselbe fuer alle uebrigen Browser. Wo das Attribut
   greift, laeuft es ins Leere, weil dann schon geschlossen ist. Doppelt
   gemoppelt, aber ohne Nebenwirkung.
--------------------------------------------------------------------------- */
(function () {
  var gruppen = document.querySelectorAll('.kindooly-details__liste, .kindooly-faq__liste');
  if (!gruppen.length) return;

  Array.prototype.forEach.call(gruppen, function (gruppe) {
    var felder = gruppe.querySelectorAll('details');
    Array.prototype.forEach.call(felder, function (feld) {
      feld.addEventListener('toggle', function () {
        if (!feld.open) return;
        Array.prototype.forEach.call(felder, function (anderes) {
          if (anderes !== feld && anderes.open) anderes.open = false;
        });
      });
    });
  });
})();

/* ---------------------------------------------------------------------------
   Stimmen-Band, 2026-08-29

   Die Karten laufen langsam nach rechts und halten an, sobald jemand sie
   anfasst. Anjas Vorgabe: "Wenn man sie lesen möchte, kann man sie anhalten
   oder wischen. Wenn man nichts macht, sliden sie langsam durch."

   WARUM NATIVES SCROLLEN UND KEINE ANIMATION: Ein Band, das per CSS-Animation
   läuft, kann man nicht anfassen. Hier scrollt ein echter Scroll-Container,
   deshalb funktionieren Wischen, Trackpad, Pfeiltasten und Screenreader ohne
   Zusatzcode. Das Skript schiebt nur weiter, wenn niemand etwas tut.

   ENDLOS OHNE SPRUNG: Die Karten stehen doppelt im Band. Sobald die erste
   Hälfte durchgelaufen ist, springt die Scrollposition um genau diese Hälfte
   zurück. Das ist nicht sichtbar, weil an beiden Stellen dasselbe steht.

   Wer im Betriebssystem weniger Bewegung eingestellt hat, bekommt ein
   stehendes Band, das sich weiterhin von Hand bedienen lässt.
--------------------------------------------------------------------------- */
(function () {
  var baender = document.querySelectorAll('[data-kindooly-bew]');
  if (!baender.length) return;

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(baender, function (band) {
    var liste = band.querySelector('.kindooly-bew__liste');
    var zurueck = band.querySelector('.kindooly-bew__pfeil--zurueck');
    var vor = band.querySelector('.kindooly-bew__pfeil--vor');
    if (!liste) return;

    var tempo = parseFloat(band.dataset.tempo);
    if (isNaN(tempo)) tempo = 25;

    /* KARTEN VERDOPPELN, damit die Schleife ohne Sprung schliesst.

       Seit dem 2026-09-08 auch dann, wenn das Band steht. Anja will die
       Pfeile endlos durchklicken koennen: "wenn man nach der letzten
       Bewertung weiter nach rechts klickt, dann geht es von vorne wieder
       los." Das braucht die Kopien, sonst gaebe es nichts, wohin gescrollt
       werden koennte, und der Sprung waere sichtbar.

       Bei abgeschalteter Bewegung im Betriebssystem laeuft das Band
       weiterhin nicht von selbst, die Pfeile funktionieren aber. */
    var karten = liste.querySelectorAll('.kindooly-bew__karte');
    var verdoppelt = false;
    if (karten.length) {
      Array.prototype.forEach.call(karten, function (k) {
        var kopie = k.cloneNode(true);
        kopie.setAttribute('aria-hidden', 'true');
        liste.appendChild(kopie);
      });
      verdoppelt = true;
    }

    /* DIE PERIODE ist der Abstand zwischen einer Karte und ihrer Kopie.
       Ein Sprung um genau diesen Betrag ist unsichtbar, weil an beiden
       Stellen dasselbe steht.

       NICHT scrollWidth / 2 NEHMEN. Das war am 2026-09-08 der erste Versuch
       und lag 49 px daneben: Die Liste hat links und rechts einen eigenen
       Innenabstand, der in scrollWidth steckt, aber nur einmal und nicht
       je Haelfte. Der Sprung verschob die Karten dadurch sichtbar.

       Gerechnet wird deshalb aus den Karten selbst: erste Kopie minus erste
       Karte. Das Ergebnis ist unabhaengig von Abstaenden und Rundungen. */
    var anzahlOriginal = karten.length;
    function periode() {
      var alle = liste.querySelectorAll('.kindooly-bew__karte');
      if (!verdoppelt || alle.length <= anzahlOriginal) return liste.scrollWidth;
      return alle[anzahlOriginal].offsetLeft - alle[0].offsetLeft;
    }

    function schrittweite() {
      var erste = liste.querySelector('.kindooly-bew__karte');
      if (!erste) return 320;
      var stil = window.getComputedStyle(liste);
      var abstand = parseFloat(stil.columnGap || stil.gap) || 16;
      return erste.getBoundingClientRect().width + abstand;
    }

    /* ENDLOS IN BEIDE RICHTUNGEN, 2026-09-08.

       Der Sprung passiert VOR dem Scrollen, nicht danach. Sonst liefe erst
       die weiche Bewegung bis zum Anschlag und danach zuckte die Liste, das
       sieht man. So wird zuerst hart an die gleichwertige Stelle gesetzt und
       von dort weich weitergescrollt, und weil an beiden Stellen dasselbe
       steht, faellt das Setzen nicht auf.

       Der Rest bleibt: Ein Klick haelt das Band vier Sekunden an. */
    if (zurueck) zurueck.addEventListener('click', function () {
      var weite = schrittweite();
      if (liste.scrollLeft - weite < 0) {
        liste.scrollLeft = liste.scrollLeft + periode();
      }
      liste.scrollBy({ left: -weite, behavior: 'smooth' });
      pausiere(4000);
    });

    if (vor) vor.addEventListener('click', function () {
      var weite = schrittweite();
      /* Steht die Liste schon in der Kopie, erst um eine Periode zurueck.
         Dann bleibt nach rechts immer Platz und der Anschlag am Ende des
         Scrollbereichs wird nie erreicht. */
      if (liste.scrollLeft >= periode()) {
        liste.scrollLeft = liste.scrollLeft - periode();
      }
      liste.scrollBy({ left: weite, behavior: 'smooth' });
      pausiere(4000);
    });

    if (tempo <= 0 || ruhig) return;

    var pauseBis = 0;
    var letzte = null;

    /* DIE POSITION WIRD SELBST GEFUEHRT, seit dem 2026-09-08.

       Vorher stand hier scrollLeft = scrollLeft + tempo * delta, also lesen,
       addieren, zurueckschreiben. Das kann nicht funktionieren: Der Browser
       rundet scrollLeft auf ganze Pixel. Bei 25 px in der Sekunde und 60
       Bildern sind das 0,42 px je Schritt, gerundet null. Am 2026-09-08
       nachgemessen: scrollLeft = 0.4 ergibt 0, scrollLeft = 0.9 ergibt 1.

       Der Bruchteil ging also bei jedem Bild verloren und das Band stand
       still, egal wie lange man wartete. Anja: "es läuft immer noch nicht."

       Jetzt sammelt pos die Bruchteile, und nur der Gesamtwert wandert nach
       scrollLeft. Nach jeder Pause wird pos aus der tatsaechlichen Stelle
       neu gesetzt, damit Wischen und Pfeile nicht ueberschrieben werden. */
    var pos = null;

    function pausiere(ms) { pauseBis = Date.now() + ms; }

    // Jede Beruehrung haelt an. Nach der Ruhezeit laeuft es weiter.
    ['pointerdown', 'touchstart', 'focusin'].forEach(function (e) {
      band.addEventListener(e, function () { pausiere(6000); }, { passive: true });
    });

    /* DAS MAUSRAD HAELT DAS BAND NICHT MEHR AN, seit dem 2026-09-10.

       Anja: "das Band läuft, aber stoppt, wenn ich mit dem Cursor drüber
       komme."

       wheel stand bis dahin in der Liste oben und setzte sechs Sekunden
       Pause. Wer die Seite liest, scrollt aber fast durchgehend, und dabei
       steht der Zeiger sehr oft ueber dem Band. Jedes Radereignis verlaengerte
       die Pause, das Band kam nie wieder in Gang. Aus Sicht der Bedienung war
       das Rad hier auch nie gemeint: Es scrollt die Seite nach unten, nicht
       das Band zur Seite.

       Waagerechtes Wischen auf dem Trackpad ist etwas anderes, das gilt dem
       Band. Es kommt ebenfalls als wheel an, nur mit deltaX statt deltaY, und
       haelt weiterhin an. */
    band.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) pausiere(6000);
    }, { passive: true });
    /* BIS ZUM 2026-09-06 hielt der Zeiger ueber dem Band es zehn Minuten an.
       Gedacht war das als Lesehilfe, in der Praxis stand das Band damit die
       meiste Zeit still: Auf der Produktseite wandert der Zeiger beim Scrollen
       fast zwangslaeufig darueber. Anja am 2026-09-06: "die Bewertungen sollen
       genau so langsam durchlaufen."

       Jetzt haelt nur noch an, wer wirklich etwas tut: tippen, wischen,
       scrollen, Tastaturfokus. Das steht in der Liste darueber. */
    band.addEventListener('mouseleave', function () { pausiere(1200); });

    /* TEXT MARKIEREN UND KOPIEREN, 2026-09-06.

       Anja: "Ich kann die Texte der Bewertungen nicht kopieren." Ursache war
       nicht user-select, sondern die Bewegung: Wer markieren will, zieht ueber
       Text, der unter dem Zeiger wegwandert. Vor dem 2026-09-06 fiel das nicht
       auf, weil der Zeiger ueber dem Band es ohnehin zehn Minuten anhielt.

       Jetzt haelt das Band an, SOLANGE eine Auswahl in ihm steht, und laeuft
       eine Sekunde nach dem Aufheben weiter. Damit bleibt beides: Es laeuft
       durch, und man kann trotzdem etwas herausziehen. */
    document.addEventListener('selectionchange', function () {
      var auswahl = document.getSelection();
      if (!auswahl || auswahl.isCollapsed) return;
      var knoten = auswahl.anchorNode;
      if (knoten && knoten.nodeType === 3) knoten = knoten.parentElement;
      if (knoten && band.contains(knoten)) pausiere(1000);
    });

    function takt(zeit) {
      if (letzte === null) letzte = zeit;
      var delta = (zeit - letzte) / 1000;
      letzte = zeit;

      if (Date.now() >= pauseBis && delta < 0.5) {
        /* Nach einer Pause dort weitermachen, wo das Band wirklich steht. */
        if (pos === null) pos = liste.scrollLeft;

        pos = pos + tempo * delta;

        /* Dieselbe Grenze wie bei den Pfeilen, seit dem 2026-09-08 aus
           einer Funktion statt zweimal gerechnet. */
        if (pos >= periode()) pos = pos - periode();

        liste.scrollLeft = pos;
      } else {
        pos = null;
      }

      window.requestAnimationFrame(takt);
    }

    window.requestAnimationFrame(takt);
  });
})();

/* ---------------------------------------------------------------------------
   KI-Hinweis auf Bildern mit Personen, 2026-08-31

   Anja: "Ich moechte, dass du auf alle Bilder, die in der Galerie und
   ansonsten einzeln im Shop angezeigt werden, auf denen Kinder zu sehen sind
   (einschliesslich die erwachsene Frau im Tuch) so ein i unten rechts in die
   Ecke machst. Wenn man mit dem Cursor drueber faehrt, soll genau so eine
   KI-Information erscheinen."

   WARUM UEBER DEN ALTERNATIVTEXT: Am 2026-08-31 hat jedes Bild in der Ablage
   einen Alternativtext bekommen, und jedes Bild mit einer Person nennt sie
   dort beim Wort: Maedchen, Junge, Kind, Erwachsene. Die Sachaufnahmen
   (Karabiner, Deckenplatte, Gewebe) tun das nicht. Damit trifft die Erkennung
   genau die richtigen Bilder, ohne dass irgendwo eine Liste gepflegt werden
   muss. Tauscht Anja morgen ein Bild, wandert der Hinweis von selbst mit.

   NICHT MARKIERT WERDEN:
     - die Banderole. Anjas Ergaenzung vom selben Tag: Dort laufen nur Bilder,
       die ohnehin an anderer Stelle im Shop stehen und dort den Hinweis
       tragen.
     - Farbmuster und Vorschaubilder der Galerie. Sie sind zu klein fuer ein
       Abzeichen, und das grosse Bild daneben traegt es schon.
   Beides zusammen faengt die Mindestbreite ab: unter 180 Pixeln kein Hinweis.

   ZUR BEDIENUNG: Das Abzeichen ist ein Knopf, kein reines Hover-Element.
   Damit erreicht es auch die Tastatur und den Finger auf dem Handy, wo es
   kein Ueberfahren gibt. Der Hinweistext haengt per aria-describedby daran,
   Vorlesewerkzeuge geben ihn also mit aus.
--------------------------------------------------------------------------- */
(function () {
  var HINWEIS = 'Dieses Bild entstand mit Unterstützung durch KI.';

  // EINE BLASE FUER ALLE, am Seitenende und fest positioniert.
  //
  // Vorher hatte jedes Abzeichen seine eigene Blase im Bildrahmen. In der
  // Galerie blieb sie unsichtbar: Shrine legt dort eine Zoom-Ebene und einen
  // flaechendeckenden Knopf ueber das Bild, und auch mit z-index 31 kam die
  // Blase nicht darueber. Am 2026-08-31 mit elementsFromPoint nachgemessen.
  //
  // Am Seitenende und mit position: fixed haengt sie in keinem fremden
  // Stapel und wird von keinem overflow beschnitten. Nebenbei ist es eine
  // Blase statt 42.
  var blase = null;

  function blaseHolen() {
    if (blase) return blase;
    blase = document.createElement('div');
    blase.className = 'kindooly-ki__blase';
    blase.id = 'kindooly-ki-hinweis';
    blase.setAttribute('role', 'tooltip');
    blase.textContent = HINWEIS;
    document.body.appendChild(blase);
    return blase;
  }

  function zeigen(knopf) {
    var b = blaseHolen();
    b.classList.add('kindooly-ki__blase--offen');
    var k = knopf.getBoundingClientRect();
    var bb = b.getBoundingClientRect();
    // Ueber dem Abzeichen, rechtsbuendig, und immer im Fenster.
    var links = Math.min(
      Math.max(8, k.right - bb.width),
      window.innerWidth - bb.width - 8
    );
    var oben = k.top - bb.height - 8;
    if (oben < 8) oben = k.bottom + 8;
    b.style.left = Math.round(links) + 'px';
    b.style.top = Math.round(oben) + 'px';
  }

  function verbergen() {
    if (blase) blase.classList.remove('kindooly-ki__blase--offen');
  }
  // "kind" ohne Ausschluss traf auch das Logo, dessen Alternativtext schlicht
  // "Kindooly" lautet. Am 2026-08-31 im Browser gemessen, das Logo bekam ein
  // Abzeichen. Deshalb der negative Ausblick auf "ooly".
  // WORTGRENZE AM ENDE, seit 2026-09-14. Vorher stand hier kind(?!ooly), und
  // das hat im Alternativtext des Logos zugeschlagen: "Kindooly, play. move.
  // grow kindly." Das "kind" in "kindly" passte, und die Bildmarke bekam eine
  // KI-Kennung, obwohl sie gezeichnet ist. Anja am selben Tag: "das Logo
  // braucht nicht die Kennung für KI." Mit \b am Ende passen Kind, Kinder und
  // Kindes, aber weder Kindooly noch kindly.
  var WOERTER = /\b(mädchen|junge[n]?|kind(?:er|es|ern)?|kleinkind(?:er)?|erwachsene[rn]?)\b/i;
  // Dazu die Bildmarke selbst, damit sie auch dann aussen vor bleibt, wenn
  // jemand den Alternativtext spaeter aendert.
  // .kindooly-partnerlogo, ergaenzt 2026-09-27: Die Logos des Kinder- und
  // Jugendhospizdienstes tragen "Kinder" im Alternativtext und wurden dadurch
  // als Personenbild erkannt. Es sind fremde Vereinslogos, kein KI-Bild, und
  // der Alternativtext muss den Vereinsnamen nennen. Deshalb eine Ausnahme
  // ueber die Klasse statt ein gekuerzter Alternativtext.

  var AUSSEN = '.kindooly-bd, .color-swatch, .thumbnail-list, .thumbnail, .sticky-atc, .cart-item, .cart-drawer, .header, .footer, .kindooly-nm__marke, .kindooly-partnerlogo';
  var zaehler = 0;

  function markieren(bild) {
    if (bild.dataset.kindoolyKi) return;
    // Zweite Sperre am Rahmen. Das Bild wechselt beim Einziehen der Huelle
    // den Elternknoten, und ein spaeterer Durchgang hat es dadurch als neu
    // gesehen. Am 2026-08-31 standen deshalb 34 Abzeichen auf 17 Bildern.
    if (bild.parentElement && bild.parentElement.querySelector(':scope > .kindooly-ki')) return;
    if (!WOERTER.test(bild.alt || '')) return;
    if (bild.closest(AUSSEN)) return;
    if (bild.getBoundingClientRect().width < 180) return;

    var rahmen = bild.parentElement;
    if (!rahmen) return;

    // WELCHER RAHMEN, gefunden am 2026-08-31: Erst hing das Abzeichen einfach
    // am Elternknoten. In der Produktgalerie ist das die Liste aller Slides,
    // also ein Element, das viel breiter ist als das sichtbare Bild. Das
    // Abzeichen sass dadurch in der oberen linken Ecke statt unten rechts.
    //
    // Deshalb wird der Elternknoten gemessen. Umschliesst er das Bild nicht
    // eng, bekommt das Bild eine eigene Huelle, die genau seine Maße hat.
    var bb = bild.getBoundingClientRect();
    var rb = rahmen.getBoundingClientRect();
    // Ist das Bild absolut gesetzt, wie in Shrines Galerie, haette eine Huelle
    // darum keine Hoehe. Dann bleibt es beim vorhandenen Rahmen, der dort
    // ohnehin genau die Bildflaeche ist.
    var bildAbsolut = getComputedStyle(bild).position === 'absolute';
    if (!bildAbsolut && (Math.abs(rb.width - bb.width) > 8 || Math.abs(rb.height - bb.height) > 8)) {
      var huelleBild = document.createElement('span');
      huelleBild.className = 'kindooly-ki-rahmen';
      bild.parentNode.insertBefore(huelleBild, bild);
      huelleBild.appendChild(bild);
      rahmen = huelleBild;
    } else if (getComputedStyle(rahmen).position === 'static') {
      rahmen.style.position = 'relative';
    }

    zaehler++;

    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'kindooly-ki__knopf';
    knopf.setAttribute('aria-label', HINWEIS);
    knopf.setAttribute('aria-describedby', 'kindooly-ki-hinweis');
    knopf.textContent = 'i';

    var huelle = document.createElement('span');
    huelle.className = 'kindooly-ki';
    huelle.appendChild(knopf);

    // Auf dem Handy oeffnet ein Tippen die Blase, ein zweites schliesst sie.
    knopf.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      // Auf dem Handy oeffnet ein Tippen, ein zweites schliesst.
      if (blase && blase.classList.contains('kindooly-ki__blase--offen')) {
        verbergen();
      } else {
        zeigen(knopf);
      }
    });

    // DAS UEBERFAHREN WIRD HIER GESCHALTET, nicht nur ueber :hover im CSS.
    // In der Galerie liegt Shrines Zoom-Ebene ueber dem Bild und faengt die
    // Maus ab, bevor der Zeiger den Span erreicht. Anja am 2026-08-31: "in
    // der Galerie funktioniert das nicht, alle anderen funktionieren."
    // Mit eigenen Ereignissen am Knopf haengt es nicht mehr davon ab, welche
    // Ebene das Theme darueber legt.
    knopf.addEventListener('mouseenter', function () { zeigen(knopf); });
    knopf.addEventListener('mouseleave', verbergen);
    knopf.addEventListener('focus', function () { zeigen(knopf); });
    knopf.addEventListener('blur', verbergen);

    rahmen.appendChild(huelle);
    bild.dataset.kindoolyKi = '1';
  }

  function durchgang() {
    var bilder = document.querySelectorAll('img[alt]');
    for (var i = 0; i < bilder.length; i++) markieren(bilder[i]);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.kindooly-ki')) return;
    verbergen();
  });

  // Beim Scrollen wandert das Bild, die feste Blase nicht. Also schliessen.
  window.addEventListener('scroll', verbergen, { passive: true });
  window.addEventListener('resize', verbergen);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', durchgang);
  } else {
    durchgang();
  }

  // Die Galerie tauscht ihr grosses Bild beim Farbwechsel aus, und Shrine
  // rendert Abschnitte nach. Ein Beobachter faengt beides ab, ohne dass hier
  // ein Ereignis von Shrine bekannt sein muss.
  if (window.MutationObserver) {
    var wartend = false;
    new MutationObserver(function () {
      if (wartend) return;
      wartend = true;
      setTimeout(function () { wartend = false; durchgang(); }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ---------------------------------------------------------------------------
   Fantasie: Vorher-nachher-Schieber, 2026-08-31

   Gehoert zu sections/kindooly-fantasie.liquid. Der Regler setzt eine
   CSS-Variable, alles Weitere macht das Stylesheet: Es beschneidet das obere
   Bild und schiebt die Trennlinie mit.

   Hier steht bewusst fast nichts. Die Bedienung mit Maus, Finger und Tastatur
   bringt input type=range mit, einschliesslich Pfeiltasten, Pos1 und Ende.
--------------------------------------------------------------------------- */
(function () {
  var regler = document.querySelectorAll('.kindooly-fa__regler');
  if (!regler.length) return;

  Array.prototype.forEach.call(regler, function (r) {
    var buehne = r.closest('.kindooly-fa__buehne');
    if (!buehne) return;

    function setzen() {
      buehne.style.setProperty('--kindooly-fa-pos', r.value + '%');
    }

    r.addEventListener('input', setzen);
    setzen();
  });
})();

/* ---------------------------------------------------------------------------
   KEIN EINZELNES WORT AUF EINER ZEILE, der Rest davon

   Anja am 2026-09-14: "Das moechte ich im ganzen Shop vermeiden."

   Die Hauptarbeit macht CSS, siehe den gleichnamigen Abschnitt am Ende von
   kindooly.css: balance fuer Ueberschriften, pretty fuer Fliesstext. Das hat
   die Funde von 68 auf 28 gedrueckt.

   WO CSS AUFHOERT: Chromes pretty zieht ein Wort nur dann mit herunter, wenn
   die letzte Zeile sehr kurz ist. Endet ein Absatz auf ein langes Wort wie
   "Herstelleranleitung", bleibt es stehen, obwohl daneben Platz waere.

   Also dasselbe Mittel wie in kindooly-argument.liquid, nur zur Laufzeit: ein
   geschuetztes Leerzeichen vor dem letzten Wort. Das kann nicht umbrechen,
   also kann das letzte Wort nicht allein stehen.

   WARUM IM BROWSER UND NICHT IN DEN TEXTEN: Die Texte liegen in Metafeldern,
   Seiten und Theme-Einstellungen. Sie dort anzufassen hiesse, in den Shop zu
   schreiben, und der ist der Master. Hier wird nur die Anzeige geaendert,
   kein einziger gespeicherter Text.

   DREI SICHERUNGEN, damit nichts kaputt geht:
     1. Nur der letzte Textknoten wird angefasst, nie innerHTML. Damit bleiben
        Ereignisse, Verweise und Formatierungen unberuehrt.
     2. Passen die letzten beiden Woerter zusammen nicht in eine Zeile, wird
        die Aenderung sofort zurueckgenommen. Sonst entstuende ein Ueberlauf.
     3. Elemente, die ohnehin in einer Zeile stehen, werden uebersprungen.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  // Dazu zwei Sonderfaelle: die Zeile der Vertrauensleiste ist ein span, die
  // Feldbeschriftung im Rueckgabeformular ein label. Beide tragen Fliesstext
  // und brechen um, gehoeren also dazu. Andere span bleiben aussen vor, sonst
  // greift die Funktion in jede Textauszeichnung hinein.
  var AUSWAHL = 'h1, h2, h3, h4, h5, h6, p, li, dd, dt, figcaption, blockquote, label, span.kindooly-vt__text';
  var NICHT = '.visually-hidden, .skip-to-content-link, [aria-hidden="true"], .nowrap';

  function zeilenzahl(el) {
    var hoehe = el.getBoundingClientRect().height;
    var zeile = parseFloat(getComputedStyle(el).lineHeight);
    if (!zeile || isNaN(zeile)) return 2;
    return Math.round(hoehe / zeile);
  }

  function letzterTextknoten(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var letzter = null;
    var n;
    while ((n = w.nextNode())) {
      if (n.textContent.trim()) letzter = n;
    }
    return letzter;
  }

  // PRUEFT, OB DAS BINDEN DIE WAISE NUR VERSCHOBEN HAT. Am 2026-09-14 auf der
  // Rueckgabeseite passiert: Aus "... in der E-Mail zu deiner Bestellung."
  // wurde durch das geschuetzte Leerzeichen "... in der E-Mail", darunter
  // "zu", darunter "deiner Bestellung." Das letzte Wort stand nicht mehr
  // allein, dafuer das vorletzte. Gemessen werden die letzten fuenf Woerter:
  // Steht eines davon als einziges auf seiner Zeile, wird zurueckgenommen.
  function alleinstehendesWort(tn) {
    var text = tn.textContent;
    var stellen = [];
    var suche = /\S+/g;
    var treffer;
    while ((treffer = suche.exec(text))) stellen.push([treffer.index, suche.lastIndex]);
    if (stellen.length < 2) return false;
    var ab = Math.max(0, stellen.length - 5);
    var zeilen = {};
    for (var i = ab; i < stellen.length; i++) {
      var rg = document.createRange();
      rg.setStart(tn, stellen[i][0]);
      rg.setEnd(tn, stellen[i][1]);
      var oben = Math.round(rg.getBoundingClientRect().top);
      zeilen[oben] = (zeilen[oben] || 0) + 1;
    }
    var schluessel = Object.keys(zeilen);
    // Die oberste gemessene Zeile kann Woerter enthalten, die vor dem
    // Messfenster liegen. Sie zaehlt deshalb nicht mit.
    for (var k = 1; k < schluessel.length; k++) {
      if (zeilen[schluessel[k]] === 1) return true;
    }
    return false;
  }

  function binden(el) {
    if (el.dataset.kindoolyWaise) return;
    if (el.closest(NICHT)) return;
    if (el.querySelector(AUSWAHL)) return;
    if (zeilenzahl(el) < 2) return;

    // WENIGER ALS VIER WOERTER: nicht anfassen. Bei drei Woertern auf zwei
    // Zeilen steht immer eines allein, das geschuetzte Leerzeichen wuerde die
    // Waise nur von unten nach oben schieben. "Die schwer runterkommen" waere
    // dann "Die" und darunter "schwer runterkommen". Solche Stellen brauchen
    // einen anderen Text oder mehr Platz, nicht diese Funktion.
    if (el.textContent.trim().split(/\s+/).length < 4) return;

    // DER MERKER STEHT BEWUSST HIER UNTEN, hinter allen Vorpruefungen. Im
    // ersten Entwurf stand er ganz oben, und das hat die halbe Arbeit still
    // verhindert: Ein Absatz in einem zugeklappten Bereich ist null Pixel
    // hoch, gilt damit als einzeilig und stieg aus, nachdem der Merker schon
    // gesetzt war. Beim Aufklappen aendert sich seine Breite nicht, also kam
    // er nie wieder an die Reihe. Am 2026-09-14 an der Lieferumfang-Sektion
    // gesehen. Ein Versuch, der zurueckgenommen wurde, wird erst wieder
    // aufgenommen, wenn sich die Breite aendert.
    var breite = Math.round(el.getBoundingClientRect().width);
    if (el.dataset.kindoolyBreite === String(breite)) return;
    el.dataset.kindoolyBreite = String(breite);

    var tn = letzterTextknoten(el);
    if (!tn) return;

    var text = tn.textContent;
    var treffer = text.match(/(\s+)(\S+)(\s*)$/);
    if (!treffer) return;
    if (treffer[1].indexOf('\u00a0') !== -1) return;

    var vorher = el.getBoundingClientRect().height;
    var alt = text;
    tn.textContent = text.replace(/\s+(\S+)(\s*)$/, '\u00a0$1$2');
    var nachher = el.getBoundingClientRect().height;

    // Wird der Block hoeher, haben die letzten beiden Woerter nicht mehr
    // nebeneinander Platz. Dann ist das Original das kleinere Uebel.
    // NUR DIE HOEHE ZAEHLT. Der erste Entwurf hat zusaetzlich scrollWidth
    // gegen clientWidth geprueft. Das hat am 2026-09-14 mehrere Absaetze
    // faelschlich verworfen: In einem Flex- oder Rasterfeld ist scrollWidth
    // auch ohne Zutun groesser, die Pruefung schlug also immer an. Waechst
    // der Block nicht, haben die beiden Woerter nebeneinander Platz.
    if (nachher > vorher || alleinstehendesWort(tn)) {
      tn.textContent = alt;
      return;
    }
    el.dataset.kindoolyWaise = '1';
  }

  function lauf() {
    var alle = document.querySelectorAll(AUSWAHL);
    Array.prototype.forEach.call(alle, binden);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lauf);
  } else {
    lauf();
  }

  // Nach dem Laden der Schriften bricht der Text neu um, und bei einer
  // Groessenaenderung ebenso. Beide Male noch einmal nachsehen.
  // NACH DEM LADEN DER SCHRIFTEN muessen auch die Merker weg. Sonst gilt ein
  // Versuch, der mit der Ersatzschrift gescheitert ist, fuer immer als
  // erledigt, obwohl die richtige Schrift schmaler misst. Am 2026-09-14 an
  // einem Absatz der Lieferumfang-Sektion gesehen.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      var alle = document.querySelectorAll('[data-kindooly-breite]');
      Array.prototype.forEach.call(alle, function (el) { delete el.dataset.kindoolyBreite; });
      lauf();
    });
  }

  window.addEventListener('load', lauf);

  // ZWEI SPAETE LAEUFE. Manche Sektionen bauen ihre Inhalte erst nach dem
  // Laden auf, die Lieferumfang-Sektion zum Beispiel. Deren Absaetze stehen
  // beim ersten Durchgang noch gar nicht im Dokument, und eine
  // Groessenmeldung kommt dabei nicht immer. Zwei Nachzuegler kosten nichts,
  // weil bereits behandelte Stellen uebersprungen werden.
  setTimeout(lauf, 1500);
  setTimeout(lauf, 3000);

  // SPAETER NOCH EINMAL, und zwar aus drei Gruenden, alle am 2026-09-14 am
  // gerenderten Shop gesehen:
  //   1. Aufklapper sind beim Laden zu, ihre Absaetze haben Hoehe null und
  //      gelten deshalb als einzeilig.
  //   2. Das Karussell der Kundenstimmen baut seine Karten erst nach dem
  //      Laden auf die endgueltige Breite um.
  //   3. Die Rabattlasche ist eingeklappt, bis jemand sie oeffnet.
  // Ein ResizeObserver auf den Seiteninhalt faengt alle drei ab, ohne dass
  // jede Sektion einzeln bekannt sein muss.
  var warte;
  function spaeter() {
    clearTimeout(warte);
    warte = setTimeout(lauf, 200);
  }

  if (window.ResizeObserver) {
    var beobachter = new ResizeObserver(spaeter);
    beobachter.observe(document.body);
  }

  document.addEventListener('toggle', spaeter, true);

  window.addEventListener('resize', function () {
    clearTimeout(warte);
    warte = setTimeout(function () {
      var alle = document.querySelectorAll('[data-kindooly-waise]');
      Array.prototype.forEach.call(alle, function (el) {
        delete el.dataset.kindoolyWaise;
        delete el.dataset.kindoolyBreite;
      });
      lauf();
    }, 250);
  });
})();

/* ---------------------------------------------------------------------------
   "mehr lesen" in den Bewertungskarten, 2026-09-20

   Anja: "Wenn Texte zu lang sind, dann soll man auf 'mehr lesen' klicken
   können und sie damit aufklappen. Aber so sollen erstmal alle Kästchen
   kleiner sein."

   Das Klemmen macht das Stylesheet, hier wird nur entschieden, WO der Knopf
   überhaupt gebraucht wird. Das lässt sich nicht in Liquid entscheiden: Ob
   ein Text über fünf Zeilen geht, hängt von Schrift, Kartenbreite und
   Fenstergröße ab und steht erst nach dem Umbruch fest.

   WARUM AM ENDE DER DATEI: Das Band weiter oben verdoppelt die Karten für
   die Endlosschleife. Liefe dieser Teil vorher, bekämen die Kopien keine
   Knöpfe, und jede zweite Runde zeigte abgeschnittene Texte ohne Ausweg.

   WARUM document.fonts.ready: Vor dem Laden der Schrift misst der Browser
   mit einer Ersatzschrift, und die bricht anders um. Am 2026-09-13 war das
   schon einmal die Ursache für eine falsche Messung an anderer Stelle.
--------------------------------------------------------------------------- */
(function () {
  var knoepfe = document.querySelectorAll('[data-kindooly-mehr]');
  if (!knoepfe.length) return;

  function pruefen() {
    Array.prototype.forEach.call(knoepfe, function (knopf) {
      var zitat = knopf.parentElement.querySelector('[data-kindooly-zitat]');
      if (!zitat) return;
      /* Ein aufgeklapptes Zitat nie wieder verstecken, sonst verschwindet
         der Knopf unter den Händen dessen, der ihn gerade gedrückt hat. */
      if (zitat.classList.contains('kindooly-bew__zitat--offen')) return;
      var laeuftUeber = zitat.scrollHeight > zitat.clientHeight + 1;
      knopf.hidden = !laeuftUeber;
    });
  }

  Array.prototype.forEach.call(knoepfe, function (knopf) {
    knopf.addEventListener('click', function () {
      var zitat = knopf.parentElement.querySelector('[data-kindooly-zitat]');
      if (!zitat) return;
      var offen = zitat.classList.toggle('kindooly-bew__zitat--offen');
      knopf.textContent = offen ? 'weniger' : 'mehr lesen';
      knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
    });
  });

  pruefen();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(pruefen);

  /* Beim Drehen des Handys ändert sich die Kartenbreite und damit der
     Umbruch. Entprellt, weil resize im Dutzend feuert. */
  var timer;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(pruefen, 200);
  });
})();

/* ===========================================================================
   COOKIE-EINSTELLUNGEN WIEDER ÖFFNEN, seit dem 2026-10-01
   ===========================================================================

   Anlass: Anja am 2026-10-01: "Cookie Banner kam auch im privaten Fenster
   nicht." Richtig war: Der Banner erscheint genau einmal. Danach ist die
   Entscheidung gespeichert und es gab keinen Weg mehr zurück. Wer einmal
   abgelehnt hatte, blieb für immer dabei.

   WARUM DAS MEHR IST ALS BEQUEMLICHKEIT: Artikel 7 Absatz 3 DSGVO verlangt,
   dass eine Einwilligung so einfach widerrufen werden kann, wie sie erteilt
   wurde. Ein Banner ohne Rückweg erfüllt das nicht.

   NEBENWIRKUNG, DIE GELD BETRIFFT: Ohne Marketing-Einwilligung lädt Shopify
   das Meta-Pixel gar nicht erst. Jeder Besucher, der ablehnt, taucht in der
   Werbemessung nie auf. Deshalb zählt Shopify immer mehr Bestellungen als
   Meta, und das ist kein Fehler.

   Shopify liefert die Funktion mit, es fehlte nur der Aufruf:
   window.privacyBanner.showPreferences()

   DER RÜCKFALL IST ABSICHT: Der Menüeintrag zeigt auf
   /policies/privacy-policy#cookie-einstellungen. Bleibt JavaScript aus oder
   fehlt die Schnittstelle, landet man auf der Datenschutzerklärung. Das ist
   kein toter Verweis, sondern die nächstbeste Seite.
   =========================================================================== */
(function () {
  var MARKE = '#cookie-einstellungen';

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href*="' + MARKE + '"]') : null;
    if (!a) return;

    var banner = window.privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') return; /* Rückfall greift */

    e.preventDefault();
    banner.showPreferences();
  });
})();
